import { getAuth } from '~/services/auth';
import type { GetResponse, LoginResponse } from '~/types';
import { initializePermissions } from '~/utils/auth/routeController';
import { clearOrgInfoCache } from '~/utils/auth/orgInfoCache';

const isAuthenticated = ref<boolean>(false);
const user = ref<string | null>(null);
const userEmail = ref<string | null>(null);
const role = ref<Array<string>>([]);
const isExpenseEnabled = ref<boolean>(false);
const expenseEnterPriceVersion = ref<boolean>(false);
const autoGrantId = ref<boolean>(false);

export const useAuth = () => {
  const checkAuth = async () => {
    try {
      const response = await getAuth<GetResponse<LoginResponse>>('/v1/get-session-data');
      setUser(response.data.data);
      await initializePermissions();
    } catch (err) {
      console.error('Authentication check failed:', err);
    }
  };

  const setUser = (userData: LoginResponse) => {
    user.value = userData.first_name;
    isAuthenticated.value = true;
    role.value = userData.role.split(',').map(role => role.trim());
    userEmail.value = userData.user_email;
    isExpenseEnabled.value = userData.expenses_module_enabled;
    expenseEnterPriceVersion.value = userData.expenses_version;
    autoGrantId.value = userData.auto_grant_id;
  };

  const logout = () => {
    user.value = null;
    isAuthenticated.value = false;
    role.value = [];
    clearOrgInfoCache();
  };

  return {
    isAuthenticated,
    user,
    userEmail,
    role,
    checkAuth,
    setUser,
    isExpenseEnabled,
    expenseEnterPriceVersion,
    autoGrantId,
    logout
  };
};
